import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_jewelry_necklaces: FaireCategoryEntity = {
  token: "cat_jewelry-necklaces",
  type: "category",
  name: "Necklaces",
  level: 2,
  parentToken: "cat_jewelry",
  href: "/category/jewelry/necklaces",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
